import { useMemo } from "react";
import { useLang } from "./i18n";

/**
 * Locale-aware EUR formatter hook. Reactive to the language switch because it reads
 * from LangProvider context (not <html lang>, which is stale on first paint).
 *
 *   const formatEUR = useFormatEUR();
 *   formatEUR(150)  // "150,00 €" in FR, "€150.00" in EN
 */
export const useFormatEUR = () => {
  const { lang } = useLang();
  return useMemo(() => {
    const locale = lang === "en" ? "en-GB" : "fr-FR";
    const fmt = new Intl.NumberFormat(locale, { style: "currency", currency: "EUR" });
    return (n) => fmt.format(n);
  }, [lang]);
};

/** Non-reactive fallback for utility contexts where hooks are unavailable. */
export const formatEUR = (n, lang = "fr") => {
  const locale = lang === "en" ? "en-GB" : "fr-FR";
  return new Intl.NumberFormat(locale, { style: "currency", currency: "EUR" }).format(n);
};
